<script>
import RequestAgentKitDialog from "@/components/common/requestAgentKitDialog.vue";

export default {
  name: "uConnectRegistrationSection3",
  data() {
    return {
    };
  },

}
</script>

<template>
    <div class="benefits-section">
      <el-row class="benefits-section-inner" type="flex" align="middle">
        <!-- Left Column - Text Content -->
        <el-col :xs="24" :sm="12">
          <h2 class="section-title">Why Join U-Connect?</h2>

          <div class="benefit-item">
            <h3 class="benefit-item-title">Extended Market Reach:</h3>
            <p class="benefit-item-description">U-Connect connects you with interstate and international buyers, expanding your client base to new markets and helping you reach those eager for off-the-plan and new-build properties.</p>
          </div>

          <div class="benefit-item">
            <h3 class="benefit-item-title">Exclusive Off-Market Opportunities:</h3>
            <p class="benefit-item-description">Benefit from an exclusive stock list, including off-market properties that provide clients with unique investment options not found on general listings.</p>
          </div>

          <div class="benefit-item">
            <h3 class="benefit-item-title">Additional Revenue Streams:</h3>
            <p class="benefit-item-description">Gain access to commission-sharing opportunities on closed deals, providing an additional income source by supporting clients in their property journey.</p>
          </div>
        </el-col>

        <!-- Right Column - Image -->
        <el-col class="image-container-wrapper" :xs="24" :sm="12">
          <div class="image-container">
            <img
                src="../../../assets/u-connect-reg-section-3-backgroud.png"
                alt="Blueprint review process"
                class="feature-image"
            >
          </div>
        </el-col>
      </el-row>
    </div>

</template>

<style scoped lang="scss">
.benefits-section {
  padding: 20px 20px;
}
.benefits-section-inner {
  padding: 0 20px;
}

.section-title {
  color: #003333;
  font-size: 22px;
  margin-bottom: 40px;
  font-weight: 600;
}

.benefit-item {
  margin-bottom: 30px;
}

.benefit-item-title {
  color: #003333;
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: 600;
}

.benefit-item-description {
  color: #003333;
  font-size:18px;
  line-height: 1.6;
  margin: 0;
}
.image-container-wrapper {
  display: flex;
  justify-content: center;
}
.image-container {
  width: 90%;
  height: 100%;
  overflow: hidden;
}

.feature-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 768px) {
  .benefits-section-inner {
    display: flex;
    flex-direction: column;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/uConnectRegistrationSection3.vue